












































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {ArticleStore} from "@/modules/article/store";
import ArticleSearch from "@/modules/article/List/components/Search/index.vue";
import {ArticleParams} from "@/modules/article/params";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 50
    },
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "id",
        width: 100,
        scopedSlots: { customRender: "action" },
        align: 'center',
        ellipsis: true
    },
    {
        title: "Thumbnail",
        dataIndex: "thumbnail",
        key: "thumbnail",
        scopedSlots: { customRender: "thumbnail" },
        width: 100,
        align: 'center',
        ellipsis: true
    },
    {
        title: "Tên tin tức",
        dataIndex: "name",
        key: "name",
        width: 200,
        ellipsis: true
    },
    {
        title: "Tác giả",
        dataIndex: "author",
        key: "author",
        width: 150,
        ellipsis: true
    },
    {
        title: "Mô tả",
        dataIndex: "description",
        key: "description",
        width: 200,
        ellipsis: true
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        width: 150,
        scopedSlots: { customRender: "status" },
        ellipsis: true
    }
]
@Component({
    name: "ArticleList",
    components: {CommonStatusLabel, ArticleSearch}
})
export default class extends mixins(CommonMixin) {
    columns = [...columns];

    created() {
        if (this.isAdmin) {
            this.columns = [
                ...this.columns,
                {
                    title: "Bưu cục áp dụng",
                    dataIndex: "postOffice.name",
                    key: "postOffice",
                    width: 150
                },
            ];
        }
        const params = new ArticleParams();
        ArticleStore.updateParams(params);
        ArticleStore.listArticles(params);
    }

    get articles() {
        return Object.values(ArticleStore.data);
    }

    get pagination() {
        return {
            current: ArticleStore.meta.page,
            pageSize: ArticleStore.meta.limit,
            total: ArticleStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} tin tức`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ArticleStore.listArticles({...ArticleStore.params, page: pagination.current, limit: pagination.pageSize});
    }

    async onConfirm(id: any) {
        try {
            await ArticleStore.deleteArticle(id);
            this.$message.success("Xóa tin tức thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa tin tức thất bại");
        }
    }
}
